import { TbArrowMoveRight } from "react-icons/tb"; 
import { BiLockOpenAlt } from "react-icons/bi"; 
import { BiLockAlt } from "react-icons/bi"; 
import { FaSquareFull } from "react-icons/fa";
import { TbStatusChange } from "react-icons/tb"; 
import { MdInventory } from "react-icons/md"; 
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
//import * as FxFetch from '../../fx/FxFetch';
import * as FxTable from '../../fx/FxTable';
import GxList from '../../gx/GxList';
//import CxDialog from '../../cx/CxDialog';
import { clearStore, StoreStock } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { useWindowSize } from '../../hx/useWindowSize';
//import CxIconButton from '../../cx/CxIconButton';
import { getStoreValue } from "../../gx/GxStore";
//import { useAccess } from '../../hx/useAccess';
import CxSnackbar from '../../cx/CxSnackbar';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxDlgTable from '../../cx/CxDlgTable';
import * as FxStr from '../../fx/FxStr';
import MxStockroomListTransferDlg from './MxStockroomListTransferDlg';


const MxStockroomList = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ isFullAccess }] = useAccess(trans('field.stockrooms'));
  const [{ navTo }] = useNav();

  const size = useWindowSize();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const r_dlg_transfer = React.useRef(null);
  
  const [lockOps, setLockedOps] = React.useState(true);

  const [storeStock, setStoreStock] = useSessionStorage('StoreStock', StoreStock);

  const hasColumnTotal = () => { return Boolean(localStorage.getItem('MxStockroomList.addcol_theTotalPrice')==='1')};
  const hasColumnStockMin = () => { return Boolean(localStorage.getItem('MxStockroomList.addcol_nuStockMin')==='1')};
  const hasColumnStockMax = () => { return Boolean(localStorage.getItem('MxStockroomList.addcol_nuStockMax')==='1')};
  const hasColumnReference = () => { return Boolean(localStorage.getItem('MxStockroomList.addcol_txReference')==='1')};
  const hasColumnSupplier = () => { return Boolean(localStorage.getItem('MxStockroomList.addcol_txSupplier')==='1')};

  const r_list = React.useRef(null);
  const r_dlgtable_branches = React.useRef(null);

  const [curBranch, setCurBranch] = React.useState({
    inBranch: storeStock.inBranch || getStoreValue('StoreSession', 'inBranch'),
    txBranch: storeStock.txBranch || getStoreValue('StoreSession', 'txBranch'),
    txBranchId: storeStock.txBranchId || getStoreValue('StoreSession', 'txBranchId')
  });
  const [dlgChangeBranch, setDlgChangeBranch] = React.useState(false);

  const r_snack_op_successful = React.useRef(null);

  React.useEffect(() => {
    clearStore('StoreStock', storeStock);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    r_list.current.setModuleName(`${trans('field.stockroom')}: ${curBranch.txBranchId}`);
    Promise.all([r_list.current.setdeepAddParams(`inBranch=${curBranch.inBranch}`)]).then((result) => {
      r_list.current.redisplay();
    });

  }, [curBranch, trans]);

  const doChangeBranch = (row) => {
    setDlgChangeBranch(false);
    if (row) {
      let newInBranch = row.original.inBranch;
      let newTxBranch = row.original.txBranch;
      let newTxBranchId = row.original.txBranchId;
      let newBranch = { inBranch: newInBranch, txBranch: newTxBranch, txBranchId: newTxBranchId };
      setCurBranch(newBranch);
    }
  }

  const openForm = async (op, row) => {
    storeStock.inStock = row.original.inStock;
    storeStock.inBranch = curBranch.inBranch;
    storeStock.txBranch = curBranch.txBranch;
    storeStock.txBranchId = curBranch.txBranchId;
    storeStock.inPs = row.original.inPs;
    storeStock.txPs = row.original.txPs;
    Promise.all([setStoreStock(storeStock)]).then((result) => {
      navTo("stock-form");
    });
  }

  const openLots = () => {
    // 2026-06-08 - daq: uso storeStock para pasarle la sucursal elegida.
    storeStock.inStock = null;
    storeStock.inBranch = curBranch.inBranch;
    storeStock.txBranch = curBranch.txBranch;
    storeStock.txBranchId = curBranch.txBranchId;
    storeStock.inPs = null;
    storeStock.txPs = null;
    Promise.all([setStoreStock(storeStock)]).then((result) => {
      navTo("stock-lot-list");
    });
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: "ID", accessor: "inStock", show: false });
      cols.push({ id: "inPs", Header: "inPs", accessor: "inPs", show: false });
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '30%' });
      cols.push({ id: id++, Header: trans('field.code'), accessor: "txPsCode", highlight: true, width: '15%' });
      cols.push({ id: id++, Header: trans('field.reference'), accessor: "txReference", width: '15%', show: hasColumnReference() });
      cols.push({ id: id++, Header: trans('field.supplier'), accessor: row => (row["txSupplier"]), width: '20%', align: 'left', show: hasColumnSupplier() });
      cols.push({ id: id++, Header: trans('field.group'), accessor: "txTypePsGroup", width: '20%' });
      cols.push({ id: id++, Header: trans('field.subgroup'), accessor: "txTypePsSubgroup", width: '20%' });
      cols.push({ id: id++, Header: trans('field.total'), accessor: row => (FxTable.cellTo2r00(row["theTotalPrice"])), width: '10%', align: 'right', show: hasColumnTotal() });
      cols.push({ id: id++, Header: trans('field.stock_min'), accessor: row => (FxTable.cellTo2r00(row["nuStockMin"])), width: '10%', align: 'right', show: hasColumnStockMin() });
      cols.push({ id: id++, Header: trans('field.stock_max'), accessor: row => (FxTable.cellTo2r00(row["nuStockMax"])), width: '10%', align: 'right', show: hasColumnStockMax() });
      cols.push({ id: id++, Header: trans('field.stock'), accessor: row => (FxTable.cellTo2r00(row["nuStock"])), width: '10%', align: 'right' });
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: id++, Header: "ID", accessor: "inStock", show: false });
      cols.push({ id: "inPs", Header: "inPs", accessor: "inPs", show: false });
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '50%' });
      cols.push({ id: id++, Header: trans('field.group'), accessor: "txTypePsGroup", width: '30%' });
      cols.push({ id: id++, Header: trans('field.stock'), accessor: row => (FxTable.cellTo2r00(row["nuStock"])), width: '20%', align: 'right' });
    }
    cols.push({
      id: "BTN_OPT",
      icon: <BiLockAlt style={{marginTop:'-1px'}} />, icon_alt: <BiLockOpenAlt style={{marginTop:'-1px'}} />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockedOps(!lockOps),
      accessor: row => { return <CxIconButtonNew icon={<TbArrowMoveRight fontSize={24} />} classType="ibs_iconbutton_table_body" data={row} onClick={doTransfer} disabled={lockOps} tooltip={trans('field.transfer')} /> },
      align: 'center', width: '33px'
    });

    cols.push({ id: "R", Header: "boStockBelowMin", accessor: row => Boolean(row["boStockBelowMin"] === '1'), show: false });
    return cols;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({id: 'txReference', name: trans('field.reference') + " +🔍︎", checked: hasColumnReference() ? '1' : '0'});
    cols.push({id: 'txSupplier', name: trans('field.supplier') + " +🔍︎", checked: hasColumnSupplier() ? '1' : '0'}); 
    cols.push({id: 'theTotalPrice', name: trans('field.total'), checked: hasColumnTotal() ? '1' : '0'}); 
    cols.push({id: 'nuStockMin', name: trans('field.stock_min'), checked: hasColumnStockMin() ? '1' : '0'}); 
    cols.push({id: 'nuStockMax', name: trans('field.stock_max'), checked: hasColumnStockMax() ? '1' : '0'}); 
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxStockroomList.addcol_theTotalPrice', options.includes('theTotalPrice') ? '1' : '0');
    localStorage.setItem('MxStockroomList.addcol_nuStockMin', options.includes('nuStockMin') ? '1' : '0');
    localStorage.setItem('MxStockroomList.addcol_nuStockMax', options.includes('nuStockMax') ? '1' : '0');
    localStorage.setItem('MxStockroomList.addcol_txReference', options.includes('txReference') ? '1' : '0');
    localStorage.setItem('MxStockroomList.addcol_txSupplier', options.includes('txSupplier') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  const getTooltip = () => {
    let tip = `${trans('field.ps')} / ${trans('field.code')}`;
    if (hasColumnReference()) tip = tip + `${' / ' + trans('field.reference')}`;
    if (hasColumnSupplier()) tip = tip + `${' / ' + trans('field.supplier')}`;
    
    return tip;
  }

  const doTransfer = (row) => {
    FxLog.infox('MxStockroomList.doLineOptions', '...row:', row);
    storeStock.inStock = row.inStock;
    storeStock.inBranch = curBranch.inBranch;
    storeStock.txBranch = curBranch.txBranch;
    storeStock.txBranchId = curBranch.txBranchId;
    storeStock.inPs = row.inPs;
    storeStock.txPs = row.txPs;
    Promise.all([setStoreStock(storeStock)]).then((result) => {
      r_dlg_transfer.current.setStoreStock(storeStock);
      r_dlg_transfer.current.setDlg(true);
    });
  };

  return (
    <div>
      <GxList
        moduleName={`${trans('field.stockroom')}: ${curBranch.txBranchId}`}
        xref={r_list}
        id="MxStockroomList"
        //title={trans('field.stockroom')}
        tooltip={getTooltip()}
        fullscreen
        //help="stock"
        url="stock"
        addParams={`inBranch=${curBranch.inBranch}`}
        onOpenForm={openForm}
        hasButtonAdd={false}
        refColors={ [ 'table_cell_color_red|' + trans('field.stock_below_min') ] }
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        optionalSorting={[
          { id: 'txPs', type: trans('field.ps') },
          { id: 'txPsCode', type: trans('field.code') },
        ]}
        onOptions={optionsSelected}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<TbStatusChange fontSize="24px" />} classType="ibs_iconbutton_toolbar" onClick={() => setDlgChangeBranch(true)} tooltip={`${trans('field.stockrooms_change_branch')}`} />
            <CxIconButtonNew icon={<MdInventory fontSize="24px" />} classType="ibs_iconbutton_toolbar" onClick={openLots} tooltip={`${trans('field.lots')}`} />
          </div>
        }
      />

      <MxStockroomListTransferDlg xref={r_dlg_transfer} onOk={() => {
        FxLog.infox('MxStockroomList.MxStockroomListTransferDlg', '...');
        r_list.current.refresh(); 
      }} />

      <CxDlgTable
        xref={r_dlgtable_branches}
        open={dlgChangeBranch}
        onSelect={doChangeBranch}
        onClose={() => setDlgChangeBranch(false)}
        url={'sett/branches'}
        columns={[
          { id: "0", Header: "ID", accessor: "inBranch", show: false },
          { id: "1", Header: trans('field.branch'), accessor: "txBranch", width: '50%' },
          { id: "2", Header: trans('field.branch_id'), accessor: "txBranchId", width: '25%' },
          { id: "3", Header: trans('field.color'), accessor: row => {
              return <CxIconButtonNew icon={<FaSquareFull fontSize="20px" style={{ color: FxStr.rgb2hex(row["txBranchRgb"]), border: '1px solid gray' }} />} />
            }, width: '25%', align: 'center' },
        ]}
        title={trans('field.stockrooms_change_branch')}
      />

      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />

    </div>
  );

}

export default MxStockroomList;
